<template>
  <a-layout class="equipment-parameters-content">
    <a-layout-sider :width="layoutWidth" class="leftLayout" id="leftLayout">
      <div class="treeDiv">
        <department-tree-list
          ref="departmentTreeList"
          :showSearch="true"
        ></department-tree-list>
      </div>
      <div class="retraction" v-if="showLeftBtn" @click="closeLeft">
        <div class="retractionBtn"></div>
      </div>
    </a-layout-sider>
    <a-layout-content class="rightLayout">
      <div class="retractionRight" v-if="showRightBtn" @click="openLeft">
        <div class="retractionBtn"></div>
      </div>
      <div class="content">
        <parameters ref="parameters" @initTree="initTree"></parameters>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import Parameters from './modules/parameters.vue'
import departmentTreeList from './modules/departmentTreeList.vue'

export default {
  components: {
    Parameters,
    departmentTreeList
  },
  data () {
    return {
      layoutWidth: '320',
      showLeftBtn: true,
      showRightBtn: false,
    }
  },
  watch: {
    layoutWidth (newValue, oldValue) {
      if (Number(newValue) > 0) {
        this.showRightBtn = false
        this.showLeftBtn = true
      } else {
        this.showRightBtn = true
        this.showLeftBtn = false
      }
    }
  },
  mounted () {
  },
  methods: {
    // 重新获取树
    initTree () {
      this.$refs.departmentTreeList.getTreeData()
    },
    // 收起左侧树
    closeLeft () {
      this.layoutWidth = '0'
      const dom = document.getElementById('leftLayout')
      dom.style.padding = '0px'
    },
    openLeft () {
      this.layoutWidth = '320'
      const dom = document.getElementById('leftLayout')
      dom.style.padding = '16px'
    }
  }
}
</script>
<style lang="less" scoped>
.dict-content {
  //height: 100%;
  overflow-y: hidden;
}
#leftLayout {
  background: #fff;
  padding:16px;
  margin-right:1px
}
.rightLayout {
  position: relative;
  padding: 10px 12px;
  background: #fff;
  .content {
    height: 100%;
  }
}
.treeDiv {
  height: 100%;
  overflow-y: hidden;
}
.ant-divider-horizontal {
  margin: 10px 0;
}
.retraction {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 14px;
  height: 100px;
  background: #f0f2f5;
  background: linear-gradient(135deg, transparent 10px, #f0f2f5 0) top left,
  linear-gradient(45deg, transparent 10px, #f0f2f5 0) bottom left;
  background-size: 100% 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  .retractionBtn {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 10px;
    height: 14px;
    background: #08409F;
    background: linear-gradient(135deg, transparent 7px, #08409F 0) top left,
    linear-gradient(45deg, transparent 7px, #08409F 0) bottom left;
    background-size: 100% 50%;
    background-repeat: no-repeat;
  }
}
.retractionRight {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 14px;
  height: 100px;
  background: #f0f2f5;
  background: linear-gradient(225deg, transparent 10px, #f0f2f5 0) top left,
  linear-gradient(310deg, transparent 10px, #f0f2f5 0) bottom left;
  background-size: 100% 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  .retractionBtn {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 10px;
    height: 14px;
    background: #08409F;
    background: linear-gradient(225deg, transparent 7px, #08409F 0) top left,
    linear-gradient(315deg, transparent 7px, #08409F 0) bottom left;
    background-size: 100% 50%;
    background-repeat: no-repeat;
  }
}
</style>
